import { Badge, Icon } from "@elaniintc/goes-design-system";

interface PaymentStatusBadgeProps {
  status: string;
}

export const PaymentStatusBadge = ({ status }: PaymentStatusBadgeProps) => {
  const variants = {
    PAID: {
      variant: "success" as const,
      icon: "check",
      label: "Completado",
    },
    PENDING: {
      variant: "warning" as const,
      icon: "clock",
      label: "Pendiente",
    },
    REJECTED: {
      variant: "danger" as const,
      icon: "triangle-exclamation",
      label: "Rechazado",
    },
    EXPIRED: {
      variant: "danger" as const,
      icon: "triangle-exclamation",
      label: "Expirado",
    },
    FAILED: {
      variant: "danger" as const,
      icon: "triangle-exclamation",
      label: "Fallido",
    },
    CANCELLED: {
      variant: "danger" as const,
      icon: "triangle-exclamation",
      label: "Cancelado",
    },
    EXEMPT: {
      variant: "neutral" as const,
      icon: "circle-minus",
      label: "Exonerado",
      iconClass: "text-body-quiet",
    },
  };

  const config = variants[status as keyof typeof variants] || variants.PENDING;

  const getIconClass = () => {
    switch (status) {
      case "PAID":
        return "text-success-quiet";
      case "PENDING":
        return "text-warning-quiet";
      case "REJECTED":
      case "EXPIRED":
      case "FAILED":
      case "CANCELLED":
        return "text-danger-quiet";
      case "EXEMPT":
        return "text-body-quiet";
      default:
        return "text-warning-quiet";
    }
  };

  return (
    <Badge variant={config.variant} className="h-6">
      {config.label}
      <Icon
        type="fas"
        name={config.icon}
        className={`${getIconClass()} text-xs`}
      />
    </Badge>
  );
};
